// external libs
import { useEffect, useState } from 'react'

// components
import RevertProjectStatusButton from './RevertProjectStatusButton'
import RevertProjectStatusDialog from './RevertProjectStatusDialog'

// hooks
import useProject from '../../../../services/web/useProject'
import useFolderAndTab from '../useFolderAndTab'
import useAppFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useAppFolderAndTabAction from '../../../../stores/appFolderAndTab/appFolderAndTabAction'

// types
import type { RevertOption } from '../../../../services/web/useProject'
import type { GetProjectResultType as Project } from '../../../../services/web/types/responseWebServiceTypes'

export interface RevertProjectStatusProps {
    project: Project
}

const RevertProjectStatus = (props: RevertProjectStatusProps) => {
    const { project } = props
    const projectServices = useProject()
    const folderAndTab = useFolderAndTab()
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [revertOptions, setRevertOptions] = useState<RevertOption[]>([])

    const reloadProject = () => {
        const isReloadProjectData = true
        const ignoreCustomFolder = true
        folderAndTab.loadTabAndFolder(project, appFolderAndTabStore, isReloadProjectData, ignoreCustomFolder)
        appFolderAndTabAction.resetTabDirty()
    }

    const handleSubmitted = () => {
        setIsOpen(false)
        reloadProject()
    }

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const { result } = await projectServices.getRevertOptions(project.projectID)
                setRevertOptions(result ?? [])
            } catch (error) {
                console.error(error)
            }
        }

        fetchOptions()
    }, [project.projectID, project.stepID])

    if (revertOptions.length === 0) {
        return null
    }

    return (
        <>
            <RevertProjectStatusButton onClick={() => setIsOpen((prev) => !prev)} />
            <RevertProjectStatusDialog
                isOpen={isOpen}
                projectId={project.projectID}
                revertOptions={revertOptions}
                onClose={() => setIsOpen(false)}
                onSubmitted={handleSubmitted}
            />
        </>
    )
}

export default RevertProjectStatus
